import $ from 'jquery';
import { getRequestVerificationToken } from '../utility/ajax-helpers';

const resetForm = ($form, options) => {
    $form.find('input[type=text]').val('');
    $form.find(options.selectors.error).text('');
    $form.find('.field-validation-error').hide();
};

const setItemToFavorite = (evt, $form, options) => {
    resetForm($form, options);
    const $trigger = $(evt.currentTarget);

    const item = $trigger.data('item');
    const tintingRecipeSequenceNo = $trigger.data('tinting-recipe');

    let selected = $trigger.attr('data-favorites').toString();
    if (selected && selected.indexOf(',') > 0) {
        selected = selected.split(',');
    }

    $form.find(options.selectors.item).val(item);
    $form.find(options.selectors.tintingRecipeSequenceNo).val(tintingRecipeSequenceNo);
    const $choices = $form.find(options.selectors.choice);
    $choices.each((i, choice) => {
        const $choice = $(choice);
        if (selected && selected.length > 0 && selected.indexOf($choice.val()) >= 0) {
            $choice.prop('checked', true);
        } else {
            $choice.prop('checked', false);
        }
    });
};

const updateItemFavorite = (evt, options) => {
    evt.preventDefault();

    const $form = $(evt.currentTarget);
    const $submit = $form.find('[type=submit]');
    const $error = $form.find(options.selectors.error);

    if ($form.find(':checked').length <= 0 && !$form.find('input[type=text]').valid()) {
        $form.find('.field-validation-error').show();
        return;
    }

    const data = $form.serializeArray().reduce(function (obj, item) {
        if (obj[item.name]) {
            if (typeof obj[item.name] === 'object') {
                obj[item.name].push(item.value);
            } else {
                obj[item.name] = [obj[item.name], item.value];
            }
        } else {
            obj[item.name] = item.value;
        }
        return obj;
    }, {});

    const params = {
        url: evt.currentTarget.action,
        type: evt.currentTarget.method,
        data,
        headers: {
            ...getRequestVerificationToken
        }
    };

    $submit.addClass('loading');
    $error.text('');

    $.ajax(params)
        .done((response) => {
            if (response.Success) {
                const $trigger = $(`${options.selectors.trigger}[data-item=${$form.find(options.selectors.item).val()}]`);
                $trigger.attr('data-favorites', response.SelectedFavorites);
                if (response.SelectedFavorites && response.SelectedFavorites.length > 0) {
                    $trigger.addClass('active');
                } else {
                    $trigger.removeClass('active');
                }
                $.fancybox.close();
                if (response.Favorites) {
                    $form.find(options.selectors.placeholder).html(response.Favorites);
                }
            } else {
                $error.text(response.ErrorMessage);
            }
        })
        .fail((error) => {
            $error.text(`${error.status} - ${error.statusText}`);
        })
        .always(() => {
            $submit.removeClass('loading');
        });
};

const init = (selectorScope = '', opts) => {
    if (!selectorScope) {
        console.warn('Component triggered without scope');
        return;
    }

    const scope = selectorScope;

    const defaults = {
        selectors: {
            trigger: '.js-fav-product-trigger',
            form: '.js-fav-product-form',
            item: '.js-fav-product-item',
            tintingRecipeSequenceNo: '.js-fav-product-tinting-recipe-sequence-no',
            choice: '.js-fav-product-choice',
            placeholder: '.js-fav-product-placeholder',
            error: '.js-fav-product-err'
        }
    };

    const options = $.extend(true, defaults, opts);

    const $scope = $(scope);
    if (!$scope.length) {
        return;
    }

    const $form = $(options.selectors.form);
    $scope.on('click', options.selectors.trigger, (evt) => setItemToFavorite(evt, $form, options));
    $form.on('submit', (evt) => updateItemFavorite(evt, options));
    $form.on('change', '[type=checkbox]', () => $form.find('.field-validation-error').hide());
};

export default {
    init
};
